require('../scss/irStock.scss');
// require('bootstrap-sass/assets/stylesheets/_bootstrap.scss');
require('../scss/utils/bootstrap/bootstrap.min.css');
var Highcharts = require('highcharts/highstock');

var up = require('../img/upStock.png')
var down = require('../img/downStock.png')

require('animate.css/animate.min.css');
var $ = require('jquery');
var common = require('./common');
var lang=''
$(document).ready(function () {
    $('#ir').addClass('active');
    lang = common.initChangePage();
    var baseUrl = common.getAPI();
    var ajaxUrl = baseUrl + 'v1/ir/stock/price/history';
    var ajaxUrlPrice = baseUrl + 'v1/ir/stock/price';

    $.ajax({
        url: ajaxUrl,
        type: 'get',
        dataType: 'json',
        success: function (data) {
            if (!data.status) {
                alert('读取股票数据失败！');
                return false;
            }
            data = data.result.data;
            var ohlc = [],
                volume = [],
                dataLength = data.length,
                groupingUnits = [[
                    'week',
                    [1]
                ], [
                    'month',
                    [1, 2, 3, 4, 6]
                ]],
                i = 0;
            for (i; i < dataLength; i += 1) {
                ohlc.push([
                    data[i][0], // the date
                    data[i][1], // open
                    data[i][2], // high
                    data[i][3], // low
                    data[i][4] // close
                ]);
                volume.push([
                    data[i][0], // the date
                    data[i][5] // the volume
                ]);
            }
            // create the chart
            var chart = Highcharts.stockChart('containerChart', {
                rangeSelector: {
                    selected: 1,
                    inputDateFormat: '%Y-%m-%d'
                },

                xAxis: {
                    dateTimeLabelFormats: {
                        millisecond: '%H:%M:%S.%L',
                        second: '%H:%M:%S',
                        minute: '%H:%M',
                        hour: '%H:%M',
                        day: '%m-%d',
                        week: '%m-%d',
                        month: '%y-%m',
                        year: '%Y'
                    }
                },
                tooltip: {
                    split: false,
                    shared: true,
                },
                yAxis: [{
                    labels: {
                        align: 'right',
                        x: -3
                    },
                    title: {
                        text: '股价'
                    },
                    height: '65%',
                    resize: {
                        enabled: true
                    },
                    lineWidth: 2
                }, {
                    labels: {
                        align: 'right',
                        x: -3
                    },
                    title: {
                        text: '成交量'
                    },
                    top: '65%',
                    height: '35%',
                    offset: 0,
                    lineWidth: 2
                }],
                credits: { enabled: false },
                series: [{
                    type: 'candlestick',
                    name: '华兴资本',
                    color: 'red',
                    lineColor: 'red',
                    upColor: 'green',
                    upLineColor: 'green',
                    tooltip: {

                    },
                    navigatorOptions: {
                        color: Highcharts.getOptions().colors[0]
                    },
                    data: ohlc,
                    dataGrouping: {
                        units: groupingUnits
                    },
                    id: 'sz'
                }, {
                    type: 'column',
                    data: volume,
                    yAxis: 1,
                    tooltip: {
                        pointFormat: '<span>Volume</span>: <b>{point.y}</b><br/>',
                        shared: true
                    },
                    dataGrouping: {
                        units: groupingUnits
                    }
                }]
            });

        },
        error: function (msg) {
            console.log(msg);
        }
    })

    $.ajax({
        url: ajaxUrlPrice,
        type: 'get',
        dataType: 'json',
        success: function (data) {
            if (!data.status) {
                alert('读取股票报价失败！');
                return false;
            }
            console.log(data.result, 'url');


            var res = data.result

            var today = '<span  class="smw-market-data-field smw-field-summaryDetail-dayHigh">' + res.regularMarketDayRange + '</span>'
            var weeks = '<span  class="smw-market-data-field smw-field-summaryDetail-dayHigh">' + res.fiftyTwoWeekRange + '</span>'
            var marketValue = '<spanclass="smw-market-data-field smw-field-summaryDetail-dayHigh">' + res.marketCap.toString().replace(/(\d{1,3})(?=(\d{3})+(?:$|\.))/g, '$1,') + '</span>'
            var money = '<span  class="smw-market-data-field smw-field-defaultKeyStatistics-sharesOutstanding">' + res.sharesOutstanding.toString().replace(/(\d{1,3})(?=(\d{3})+(?:$|\.))/g, '$1,') + '</span>'
            var amount = '<span  class="smw-market-data-field smw-field-quote-regularMarketVolume">' + res.regularMarketVolume.toString().replace(/(\d{1,3})(?=(\d{3})+(?:$|\.))/g, '$1,') + '</span>'

            var symbol = res.symbol
            var currency = res.currency
            var regularMarketPrice = res.regularMarketPrice
            var regularMarketChange = res.regularMarketChange.toFixed(2)
            var regularMarketChangePercent = res.regularMarketChangePercent.toFixed(2) + '%'


            var icon = res.regularMarketChangePercent > 0 ? '<img  src=' + up + ' alt=""></img>' : '<img src=' + down + ' alt=""></img>'

            res.regularMarketChangePercent < 0?$('.smw-rise').addClass('active'):null


            $('.today').html(today)
            $('.weeks').html(weeks)
            $('.marketValue').html(marketValue)
            $('.money').html(money)
            $('.amount').html(amount)
            $('.symbol').html(symbol)
            $('.currency').html(currency)
            $('.regularMarketPrice').html(regularMarketPrice)
            $('.regularMarketChange').html(regularMarketChange)
            $('.regularMarketChangePercent').html(regularMarketChangePercent)
            $('.icons').html(icon)


        },
        error: function (msg) {
            console.log(msg);
        }
    })








});







// WEBPACK FOOTER //
// ./src/irStock.js